export const BRAND_CUSTOMISATION_ROUTES = {
  overview: "/admin/brand-customisation",
  dashboard: "/admin/brand-customisation/dashboard",
  invoices: "/admin/brand-customisation/invoices",
} as const;

export const LEGACY_BRAND_CUSTOMISATION_REDIRECTS = {
  "/settings/brand-options": BRAND_CUSTOMISATION_ROUTES.dashboard,
  "/settings/invoice-template": BRAND_CUSTOMISATION_ROUTES.invoices,
  "/admin/invoice-branding": BRAND_CUSTOMISATION_ROUTES.invoices,
} as const;